const React = require('react')
const PropTypes = require('prop-types')
const classNames = require('classnames')
const { sendProEvent } = require('lib/analytics_pro')
const isUser = require('module/user/helpers/is_user')
const getSpotlight = require('module/user/helpers/get_spotlight')
const isAllowedSpotlight = require('module/user/helpers/is_allowed_spotlight')
const needsSpotlightAuth = require('module/user/helpers/needs_spotlight_auth')
const log = require('log').create('spotlight')  

class Spotlight extends React.Component {

    onClickLink(e, spotlight) {
        this.props.onClick()

        this.sendMetrics(spotlight)
    }

    onClickButton(e, spotlight) {
        this.props.onClick()

        if (! isAllowedSpotlight(this.props.user, spotlight)) {
            this.showDisabledSpotlightModal(spotlight)
            return
        }

        if (needsSpotlightAuth(spotlight)) {
            this.showDisabledSpotlightModal(spotlight)
            return
        }

        if (spotlight.mechanism === 'schedule') {
            this.showScheduleModal(spotlight)
        } else {
            this.showMessageModal(spotlight)
        }

        this.sendMetrics(spotlight)
    }

    getClassname(spotlight) {
        const { luminance } = this.props
        const className = classNames([
            'button',
            'xlarge',
            luminance, // light or dark
            'primary',
            spotlight.glyph && `glyph-${spotlight.glyph}`,
        ])
        return className
    }

    getStyle() {
        const { color } = this.props
        const button_color = `#${color}`

        const style = {
            backgroundColor: button_color,
            borderColor: button_color,
        }

        return style
    }

    sendMetrics(spotlight) {
        const { viewer, globals } = this.context
        const { user } = this.props
        if (! spotlight) return
        if (isUser(viewer, user)) return

        const $ = require('lib/jquery')
        const radio = require('lib/radio')
        const metrics = radio.metrics_profile

        // radio metrics
        metrics.trigger('spotlight:clicked', {
            type: spotlight.type,
            user: user.user_name,
            section: this.props.metrics_section,
        })

        sendProEvent('Spotlight', 'clicked')

        // performance metrics
        const input = {
            user_name: user.user_name,
            events: [], // this array intentionally left blank
        }
        const options = {
            success(output) {
                log('record/spotlight_clicks succeeded', output)
            },
            error(output) {
                log.error('record/spotlight_clicks failed', output)
            },
        }

        $.ajax({
            type: 'POST',
            url: `${globals.NODE_API}/user/performance/record/spotlight_clicks`,
            data: input,
            xhrFields: {
                withCredentials: true,
            },
            success: options.success,
            error: options.error,
        })
    }

    showScheduleModal(spotlight) {
        require.ensure([], () => {
            const ScheduleModal = require('module/schedule_modal/schedule_modal')
            const radio = require('lib/radio')
            const user = radio.profile.request('user')

            this.schedule_modal = new ScheduleModal({ user, spotlight })
        }, 'schedule-modal')
    }

    showMessageModal(spotlight) {
        require.ensure([], () => {
            const Message = require('module/message/message')
            const radio = require('lib/radio')
            const user = radio.profile.request('user')

            this.message_modal = new Message({
                user,
                spotlight,
                modal: true,
            })
        }, 'message-modal')
    }

    showDisabledSpotlightModal(spotlight) {
        require.ensure([], () => {
            const Dialog = require('module/dialog/dialog')
            const getDisabledSpotlightMessage = require('module/user/helpers/get_disabled_spotlight_message')
            const { user } = this.props
            const message = getDisabledSpotlightMessage(user, spotlight)
            Dialog.alert(message)
        }, 'disabled-spotlight-alert')
    }

    renderButton(spotlight) {
        return (
            <section className="spotlight inset">
                <button
                    type="button"
                    className={this.getClassname(spotlight)}
                    style={this.getStyle()}
                    onClick={(e) => { this.onClickButton(e, spotlight) }}
                    >
                    <span className="text ellipsis">
                        {spotlight.label}
                    </span>
                </button>
            </section>
        )
    }

    renderLink(spotlight) {
        return (
            <section className="spotlight inset">
                <a
                    href={spotlight.url}
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className={this.getClassname(spotlight)}
                    style={this.getStyle()}
                    onClick={(e) => { this.onClickLink(e, spotlight) }}
                    >
                    <span className="text ellipsis">
                        {spotlight.label}
                    </span>
                </a>
            </section>
        )
    }

    renderCall(spotlight) {
        return (
            <section className="spotlight inset">
                <a
                    href={`tel:${spotlight.text}`}
                    rel="nofollow noopener noreferrer"
                    className={this.getClassname(spotlight)}
                    style={this.getStyle()}
                    onClick={(e) => { this.onClickLink(e, spotlight) }}
                    >
                    <span className="text ellipsis">
                        Call {spotlight.text}
                    </span>
                </a>
            </section>
        )
    }

    renderSpotlight(user) {
        const spotlight = getSpotlight(user)
        if (! spotlight) return null

        if (['link', 'payment_link', 'download'].includes(spotlight.mechanism)) {
            return this.renderLink(spotlight)
        }

        if (spotlight.mechanism === 'call') {
            return this.renderCall(spotlight)
        }

        return this.renderButton(spotlight)
    }

    render() {
        const { user } = this.props
        return this.renderSpotlight(user)

        // uncomment this to render all spotlights for testing
        // const spotlights = require('data/spotlights/all')
        // return (
        //     spotlights.map(spotlight => {
        //         return this.renderSpotlight({
        //             spotlight: {
        //                 type: spotlight.id,
        //                 url: 'https://foo.com',
        //                 text: 'something',
        //             },
        //         })
        //     })
        // )
    }

}

Spotlight.propTypes = {
    user: PropTypes.object.isRequired,
    color: PropTypes.string.isRequired,
    luminance: PropTypes.oneOf([
        'light',
        'dark',
    ]).isRequired,
    metrics_section: PropTypes.string,
    onClick: PropTypes.func,
}

Spotlight.contextTypes = {
    globals: PropTypes.object.isRequired,
    viewer: PropTypes.object.isRequired,
}

Spotlight.defaultProps = {
    metrics_section: 'default',
    // default onClick handler is a noop
    onClick() {},
}

module.exports = Spotlight
